module.exports = __webpack_public_path__ + "static/media/exclamation-triangle-filled.314eb3a3.svg";